import { render, staticRenderFns } from "./InventoryStock.vue?vue&type=template&id=1ffbe2d9&scoped=true&"
import script from "./InventoryStock.vue?vue&type=script&lang=js&"
export * from "./InventoryStock.vue?vue&type=script&lang=js&"
import style0 from "./InventoryStock.vue?vue&type=style&index=0&id=1ffbe2d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffbe2d9",
  null
  
)

export default component.exports